import { generateTestId } from "@client-shared";

export const setRecentLabelsTestId = (identifier: string): string => generateTestId("RecentLabels", identifier);

// Specific testId setters for tests
export const setRecentLabelsContainerTestId = (): string => setRecentLabelsTestId("container");
export const setRecentLabelsTitleTestId = (): string => setRecentLabelsTestId("title");
export const setRecentLabelsItemTestId = (id: string): string => setRecentLabelsTestId(`item-${id}`);
export const setRecentLabelsStatusBadgeTestId = (id: string): string => setRecentLabelsTestId(`status-${id}`);
